import { findWarehouse, isLastAvailableForRent } from 'containers/Playground/utils/warehouse'
import { followObject, placeMarker } from 'containers/Playground/utils/cloud'
import { selectPlaygroundWarehouses } from '../../playgroundSlice'
import React, { useEffect, useMemo, useState } from 'react'
import useTranslation from 'hooks/useTranslation'
import { useReduxSelector } from 'store'
import { getPortalRoot } from 'utils/portal'
import ReactDOM from 'react-dom'

interface SelectedWarehouseMarkerProps {
  typeId?: string
}

const SelectedWarehouseMarker: React.FC<SelectedWarehouseMarkerProps> = ({ typeId }) => {
  const warehouses = useReduxSelector(selectPlaygroundWarehouses)
  const [object, setObject] = useState<HTMLElement | null>(null)
  const { t } = useTranslation('placeMap')

  useEffect(() => {
    if (!typeId) {
      setObject(null)
      return
    }
    const frame = requestAnimationFrame(() => {
      setObject(document.querySelector<HTMLElement>(`.object__main[data-type-id="${CSS.escape(typeId)}"]`))
    })
    return () => cancelAnimationFrame(frame)
  }, [typeId, warehouses])

  const isLast = useMemo(() => {
    if (!typeId || !warehouses) return false
    return isLastAvailableForRent(findWarehouse(typeId, warehouses), warehouses)
  }, [typeId, warehouses])

  const ref = useMemo(() => object ? followObject(object, placeMarker) : undefined, [object])

  if (!object || !ref) return null

  return ReactDOM.createPortal(
    <div
      ref={ref}
      className={`playground__marker${isLast ? ' --last' : ''}`}>
      <span>{t('yourChoice')}</span>
      {isLast && <span className='playground__marker__last'>
        <i className='icon icon--fire-bold' />
        {t('lastOneLeft')}
      </span>}
    </div>,
    getPortalRoot()
  )
}

export default SelectedWarehouseMarker
